
export class DocumentStatus {
    public static readonly Versato: number = 1;
    public static readonly Conservato: number = 2;
    public static readonly PresoInCarico: number = 3;
    public static readonly DaVerificare: number = 5;
    public static readonly ErroreTrasmissione: number = 6;
    public static readonly ScartataArchismall: number = 7;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/document-status.ts